<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table" :sort="defaultSort">
                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="showDetail(item)"
                                >
                                    <v-icon color="indigo lighten-2" v-on="on"
                                        >mdi-eye-outline</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{
                                $t('action-log.index.texts.show-log-details')
                            }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <action-log-detail ref="showLog" />
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import ActionLog from '@/models/ActionLog'
import ActionLogDetail from '@/components/dialogs/ActionLogDetail'

export default {
    components: {
        'sarala-table': SaralaTable,
        'action-log-detail': ActionLogDetail,
    },

    computed: {
        model() {
            return new ActionLog()
        },

        defaultSort() {
            return {
                prop: 'actioned_at',
                sortDesc: true,
            }
        },
    },

    methods: {
        showDetail(item) {
            this.$refs.showLog.show(item)
        },
    },
}
</script>
